import styled from 'styled-components';
import theme from '../../const/theme';

export const ServiceContainerWrap = styled.div`
    // width: 100%;
    // margin-top:-25px;
    background-size: cover;
    background-position: right;
    display: flex;
    align-items: center;
    justify-content: center;
    

`
export const ServiceContainer = styled.div`
    
    max-width: 1270px;
    background: rgba(189,179,169,0.8);    
    width: 100%;
    height: 100vh;
    padding: 3em;
    // padding-top: 150px;

    @media screen and (max-width: 1400px){
            padding: 0;
            max-width: 100;
             height: auto;

        }

        @media screen and (max-width: 768px){
            padding: 0;
            max-width: 100;
             height: auto;

        }

        @media screen and (max-width: 480px){
            padding: 50px 0;

        }
`

export const ServicesTextWrapper = styled.div`

    text-align: center;

     @media screen and (max-width: 480px){
        padding: 0px 20px;

    }
`

export const ServiceWrapper = styled.div`
    // width: 100%;
`

export const ServiceRow = styled.div`
margin: auto;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    gap:  25px;
    width: 780px;  

    @media screen and (max-width: 768px){
        justify-content: center;
        padding: 0 10px;
        align-items: center;
    }

    @media screen and (max-width: 768px){
         width: 100%; 
         gap: 10px;
    }
`


export const ServicesCard = styled.div`
    background-color: white;
    max-width: 200px;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    border-radius: 0;
    padding:30px 10px;
    // height: 200px;
    box-sizing: content-box;
    transition: all 0.2s ease-in-out;
    box-shadow: 0px 0px 20px 1px rgba(0,0,200,0.3);
        -webkit-box-shadow: 0px 0px 10px 3px rgba(0,0,200,0.1);
        -moz-box-shadow: 0px 0px 10px 3px rgba(0,0,200,0.1);
    &:hover{
        transform: scale(1.02);
        transition: all 0.2s ease-in-out;
        cursor: pointer;
    }

    @media screen and (max-width: 1180px){
        width: 25%;

    }



    @media screen and (max-width: 768px){
        width: 30%;
        margin-right: 10px;
        margin-bottom: 20px;
        padding:20px 10px 10px 10px;


    }

     @media screen and (max-width: 480px){
        width: 30%;
        height: 80px;
        margin-right: 10px;
        margin-bottom: 20px;
        padding:20px 10px 10px 10px;


    }
    
`

export const ServicesIcon = styled.img`
    height: 70px;
    margin-bottom: 10px;

     @media screen and (max-width: 480px){
            height: 35px;

    }
`

export const ServicesH1 = styled.h1`
    padding-top: 100px;
    text-transform: uppercase;
    font-family: 'Roboto-regular', sans-serif;     
    font-size: 2.7rem;
    color: ${({textWhite}) => (textWhite ? '#FFF' : theme.COLORS.PRIMARY)};
    margin-bottom: 50px;
    @media screen and (max-width: 768px){
        font-size: 2rem;
        margin-bottom: 30px; 
        text-align: center;
        //padding-top: 30px;

    }

     @media screen and (max-width: 768px){
        font-size: 1.6rem;
      

    }
`
export const ServicesH2 = styled.h2`
    font-family: 'Roboto-bold', sans-serif;     
    font-size: ${({small}) => (small ? '.9rem' : '1rem')};
    font-weight:500;
    margin-bottom: 10px;
    color: ${({textWhite}) => (textWhite ? '#FFF' : theme.COLORS.PRIMARY)};
    text-align: center;

    @media screen and (max-width: 768px){
        font-size: .8rem;
        text-align: center;
    }
        
`
export const ServicesP = styled.p`
    font-family: 'Roboto-regular', sans-serif;     
    font-size: .65rem;
    text-align: left;
    color: ${({textWhite}) => (textWhite ? '#FFF' : '#777')};
`